export const lan_number_to_language = (lan_index) => {
    switch (lan_index) {
      case 0:
        return 'es'
      case 1:
        return 'en-gb'
      default:
        return 'es'
    }
}